import product1 from "../backend/images/product1.png";
import product2 from "../backend/images/product2.png";
import product3 from "../backend/images/product3.png";
import product4 from "../backend/images/product4.png";
import product5 from "../backend/images/product5.png";
import product6 from "../backend/images/product6.png";
import product7 from "../backend/images/product7.png";
import product8 from "../backend/images/product8.png";

const data = {
  products: [
    {
      id: 1,
      title: "Livia Kaftan One",
      img: product1,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 281,
    },
    {
      id: 2,
      title: "Livia Kaftan Two",
      img: product2,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 179.99,
    },
    {
      id: 3,
      title: "Livia Kaftan Three",
      img: product3,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 349,
    },
    {
      id: 4,
      title: "Livia Kaftan Four",
      img: product4,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 225.5,
    },
    {
      id: 5,
      title: "Livia Kaftan Five",
      img: product5,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 221.15,
    },
    {
      id: 6,
      title: "Livia Kaftan Six",
      img: product6,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 123,
    },
    {
      id: 7,
      title: "Livia Kaftan Seven",
      img: product7,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 333,
    },
    {
      id: 8,
      title: "Livia Kaftan Eight" ,
      img: product8,
      desc: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout",
      price: 99.99,
    },
  ],
};

export default data;
